import { TServiceResult } from "./TServiceResult";
import { RexDateTime } from "../Dates/RexDateTime";

export class Reading
{
    SmokeID: string = "";
    Batter: number = 0;
    Ambient: number = 0;
    ProcessData: number = 0;
    SensorType: number = 0;
    SignalStrength: number = 0;
    Timestamp: RexDateTime | Date = new RexDateTime(0);
    Address: number = 0;
    Comment: string = "";
}

export type ServiceReadings = TServiceResult<Reading[]>;
export type ServiceReadingsSet = TServiceResult<Reading[][]>;

export const EmptyServiceReadings: ServiceReadings = 
{
    TheValue: [],
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}

export const EmptyServiceReadingsSet: ServiceReadingsSet =
{
    TheValue: [],
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}